import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import { UNIFIED_DIALOG_PAPER_SX } from '@/components/shared/dialogStyles';

interface Props {
  open: boolean;
}

export const AuthErrorDialog: React.FC<Props> = ({ open }) => (
  <Dialog
    open={open}
    disableEscapeKeyDown
    maxWidth={false}
    slotProps={{ paper: { sx: UNIFIED_DIALOG_PAPER_SX } }}
  >
    <DialogContent>
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
        <CancelIcon sx={{ color: 'text.disabled', fontSize: 40 }} />
      </Box>

      <Typography variant="h6" align="center" sx={{ mb: 1 }}>
        A Critical Error Occurred
      </Typography>

      <Typography id="qa-error-lbl" align="center">
        The OTD tool cannot connect to the database. To reconnect, close the browser, reopen it and sign back into the OTD tool.
      </Typography>
    </DialogContent>
  </Dialog>
);
